<template>
    <div>
        <PreLoader v-if="isLoading"/>
        <SuperAdminSchoolHead class="sash-main sas-head">
            <template v-slot:title><span class="sas-title" v-html="$t('courses')"/></template>
            <template v-slot:right>
                <div class="sas-head-center-block">
                    <v-text-field outlined dense v-model="search['title']" @keyup.enter="searchCourseByTitle"
                                  @input="search.title !== '' ? showIcon = true : showIcon = false"
                                  prepend-inner-icon="mdi-magnify"
                                  :append-icon="!showIcon ? '' : 'mdi-close'" @click:append="clearSearch"/>
                    <v-btn color="primary" @click="searchCourseByTitle" v-html="$t('search')"/>
                </div>
            </template>
        </SuperAdminSchoolHead>
        <div class="scl-ad">
            <SmartTable :schools="items" @addCourses="addCourses" :total-elements="totalElements" :page-size="pageSize"
                        :current-page="currentPage" :totalPages="totalPages"
                        @leftClick="onLeftClick" @rightClick="onRightClick">
                <template v-slot:head>
                    <th v-html="`ID`"/>
                    <th v-html="$t('title1')"/>
                    <th v-html="`Код`"/>
                    <th v-html="`Количество часов`" style="width: 200px"/>
                </template>

                <template v-slot:body="{item}">
                    <td v-html="item['id']"/>
                    <td v-html="item[langObj[currentLang]] === null ? $t('notTranslate') : item[langObj[currentLang]]"/>
                    <td :class="{'added': item['disable']}" v-html="item['courseCode']"/>
                    <td style="width: 200px">
                        <v-btn icon color="primary" @click="openModal('editAll', item)">
                            <v-icon color="primary">mdi-pencil-outline</v-icon>
                        </v-btn>
                    </td>
                </template>
            </SmartTable>
        </div>
        <v-dialog v-model="showEditCourseModal" width="350">
            <v-card class="card-style">
                <h4 v-html="selectCourse.name"/>
                <CourseHourDialog @deleteHour="deleteHour($event)" :course-hour-list="courseHourList"
                                  :class-level="classLevel" @addHourToArray="prepareHour"/>
                <div class="btn-actions" style="margin-top: 0!important;">
                    <v-btn color="primary" style=" color: white" @click="closeModal" v-text="$t('cancel')"/>
                    <v-btn color="green" style=" color: white" @click="submitUpdateAllCourseHour" v-text="$t('save')"/>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import SuperAdminSchoolHead from '@/components/super-admin/schools/SuperAdminSchoolHead'
import SmartTable from '@/components/table/SmartTable'
import { CourseService } from '@/_services/course.service'
import PreLoader from '@/components/preloader/PreLoader'
import CourseHourDialog from '@/components/hour/CourseHourDialog.vue'
const courseService = new CourseService()

export default {
  name: 'SchoolAdminCourses',
  components: { CourseHourDialog, SuperAdminSchoolHead, SmartTable, PreLoader },
  data: () => ({
    isLoading: false,
    items: [],
    adminCourses: [],
    isAddUser: false,
    showIcon: false,
    showEditCourseModal: false,
    mode: '',
    classLevel: [],
    selectCourse: {
      id: 0,
      name: ''
    },
    courseHourList: [],
    itemsSelected: 0,
    totalPages: 1,
    totalElements: 0,
    size: 10,
    pageSize: 0,
    currentPage: 1,
    search: {
      title: ''
    },
    langObj: {
      ru: 'courseTitle',
      kg: 'courseTitleKG',
      en: 'courseCode'
    }
  }),
  computed: {
    userProfile () {
      return this.$store.state.account.profile
    },

    currentLang () {
      return this.$root.$i18n.locale
    }
  },
  created () {
    for (let i = 0; i <= 11; i++) {
      this.classLevel.push(i)
    }
    this.fetchCourses(0)
  },
  methods: {
    openModal (mode, item) {
      this.mode = mode
      this.selectCourse.id = item.id
      this.selectCourse.name = item[this.langObj[this.currentLang]] === null
        ? this.$t('notTranslate') : item[this.langObj[this.currentLang]]
      this.getHourListByCourse(this.selectCourse.id)
      this.showEditCourseModal = true
    },
    getHourListByCourse (id) {
      this.courseHourList = []
      courseService.getAllCourseHourId(id).then((res) => {
        this.courseHourList = res
      }).catch(err => this.$toast.error(err))
    },
    closeModal () {
      this.showEditCourseModal = false
    },
    prepareHour () {
      const courseHourObj = {
        classLevel: 0,
        courseId: this.selectCourse.id,
        hours: 0
      }
      this.courseHourList.push(courseHourObj)
    },
    submitUpdateAllCourseHour () {
      this.courseHourList.forEach(el => {
        el.hours = parseInt(el.hours)
      })
      courseService.updateCourseHourArray(this.courseHourList).then(() => {
        this.$toast.success(this.$t('success'))
        this.showEditCourseModal = false
      }).catch(err => this.$toast.error(err))
    },
    deleteHour (x) {
      const index = this.courseHourList.indexOf(x)
      this.courseHourList.splice(index, 1)
      if (x.id) {
        courseService.deleteCourseHour(x.id).then(() => {
          this.$toast.success(this.$t('successDeleted'))
        }).catch((err) => {
          this.$toast.error(err)
        })
      }
    },

    onDeleteStudent (item, confirm) {
      if (confirm) {
        this.deleteCourseId = item.id
        this.$modal.show('delete-course-modal')
      } else {
        this.isLoading = true
        courseService._delete(this.deleteCourseId).then(() => {
          this.$modal.hide('delete-course-modal')
          this.$toast.success(this.$t('successDeleted'))
          this.filterByCourse(this.selectedCourseCode)
        }).catch((err) => {
          this.$toast.error(err)
          this.isLoading = false
        })
      }
    },
    filterByCourse (courseCode) {
      this.search.query = ''
      this.currentPage = 1
      if (courseCode) {
        this.selectedCourseCode = courseCode
        this.fetchCourses(0)
      } else {
        this.selectedCourseCode = ''
        this.fetchCourses(0)
      }
    },

    onLeftClick () {
      this.currentPage--
      this.fetchCourses(this.currentPage - 1)
    },
    onRightClick () {
      this.currentPage++
      this.fetchCourses(this.currentPage - 1)
    },

    fetchCourses (page) {
      this.isLoading = true
      courseService.listBySchool(this.userProfile.schools[0].id, this.search.title, page, 10).then((res) => {
        this.totalElements = res.totalElements
        this.pageSize = res.pageSize
        this.totalPages = res.totalPages
        this.currentPage = res.number + 1
        if (res.content) {
          this.items = res.content.map((i, index) => {
            i.index = index
            return i
          })
        } else this.items = []
        this.isLoading = false
      }).catch((err) => {
        this.$toast.error(err)
        this.isLoading = false
      })
    },
    onSelect (item) {
      this.adminCourses = this.adminCourses.map(i => {
        if (i.id === item.id) i = item
        return i
      })
      this.itemsSelected = this.adminCourses.filter(i => i.checked).length
    },
    async addCourses () {
      if (this.itemsSelected) {
        for (const item of this.adminCourses) {
          if (item.checked) {
            const data = {
              adminCourseId: item.id,
              archived: false,
              code: item.code,
              schoolId: this.userProfile.schools[0].id
            }
            await courseService.create(data).then(res => {
              console.log(res)
            }).catch(err => console.log(err))
          }
        }
        this.$toast.success(this.$t('successfulCreate'))
        this.fetchCourses()
      }
    },
    clearSearch () {
      this.showIcon = false
      this.search.title = ''
      this.searchCourseByTitle()
    },
    searchCourseByTitle () {
      this.currentPage = 1
      this.fetchCourses()
    }
  }
}
</script>

<style lang="scss" scoped>
.card-style{
    padding: 20px;
}
.school-admin-courses {
    margin-bottom: 50px;
    .smart-table__table tr td {
        &.added {
            background: #6279ffb3;
            color: #fff;
            font-weight: bold;
        }
    }
}

.top-th {
    width: 60px;
}
.sas-head-center {
    display: flex;
    gap: 8px;
    margin: 0!important;
}
.sas-head-center-block{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: nowrap;
    gap: 8px;
    margin: 0!important;
    padding: 0!important;
}
@media (max-width: 768px) {
    .sas-head-center-block{
        width: 100%;
    }
    .sas-btn{
        display: flex;
    }
    .sas-head{
        flex-wrap: wrap;
        margin: 0!important;
        align-items: center;
        justify-content: center!important;
    }
    .sas-head-center {
        flex-wrap: wrap-reverse;
        justify-content: center;
        padding: 0;
        gap: 0;
        width: 100%;
    }
    .sas-title {
        font-size: 20px!important;
        width: 100%;
        text-align: center;
    }
    .export-custom{
        flex-wrap: wrap;
        justify-content: center;
        padding: 12px 0;
    }
    .select-teacher {
        width: 100%;
    }
    .v-btn__content{
        font-size: 11px!important;
    }
}
</style>
